import React from "react";
import Footer from "./Footer";

// Inner pages keep this compatibility component, but use the same stable,
// responsive footer as the home page. The standalone mode removes the space
// reserved for the home-page newsletter card.
const FooterTwo = () => <Footer withNewsletter={false} />;

export default FooterTwo;
